import React from 'react';

import { Auth } from 'aws-amplify'

import AuthCard from './AuthCard';

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress';

class PasswordHandler extends React.Component {
    state = {
        loading: false,
        password: '',
        helpText: null,
        helpTextClass: null
    }
    handleInputChange = e => {
        this.setState({ password: e.target.value });
    }

    handleSubmit = e => {
        e.preventDefault();
        const { username } = this.props;
        const { password } = this.state;
        this.setState({ loading: true }, () => {
            Auth.signIn(username, password).then(user => {
                if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    this.props.onStateChange('new_password_required', { user });
                } else {
                    this.props.onStateChange('user_signin_complete');
                }
            }).catch(signInErr =>
                this.setState({ helpText: signInErr.message, helpTextClass: 'error', loading: false }));
        });
    }

    forgotPassword = e => {
        e.preventDefault();
        const { username } = this.props;
        this.setState({ loading: true }, () => {
            Auth.forgotPassword(username).then(data => {
                this.props.onStateChange('password_reset_requested')
            }).catch(err =>
                this.setState({ helpText: err.message, helpTextClass: 'error', loading: false  }));
        });
    }

    render() {
        const { loading, password, helpText, helpTextClass } = this.state;
        const { placeholder, allowReset } = this.props;
        return (
            <form onSubmit={this.handleSubmit}>
                <AuthCard loading={loading} {...this.props} title="Log in to Connect" subheader="Password Authentication Required"
                    helpText={helpText} helpTextClass={helpTextClass}
                    actions={
                        allowReset && (<Button fullWidth disabled={loading} onClick={this.forgotPassword} variant="outlined" color="secondary">Help! I've forgotten my password</Button>)
                    }>
                    <Grid container spacing={24}>
                        <Grid item xs>
                            <TextField
                                id="login_password" name="login_password" value={password} autoComplete="off"
                                placeholder={placeholder} fullWidth autoFocus disabled={loading}
                                onChange={this.handleInputChange}
                                margin="normal" type="password"
                            />
                        </Grid>
                        <Grid item>
                            <FormControl margin="normal">
                                <Button variant="contained" color="secondary" disabled={loading} onClick={this.handleSubmit}>Go</Button>
                            </FormControl>
                        </Grid>

                    </Grid>

                </AuthCard>
            </form>
        )
    }
}
export default PasswordHandler;


// WEBPACK FOOTER //
// ./src/Components/Authentication/AuthParts/PasswordHandler.js